import React, { Component } from 'react'

import * as utils from "../utils";
import JifitiGiftLink from "../common/components/jifiti-gift-link";

const Gifts = React.createClass({
  render: function() {
    const hasRegistries = window.evite_event.registries && Boolean(window.gift_registry_provider);
    const hasWishlist = window.wishlist_enabled;
    const showWishList = hasWishlist && !hasRegistries;

    return (
      <div className="gifts-panel">
        <HostRegistries />
        { showWishList &&
          <HostWishlist />
        }
        <JifitiGiftLink compactVersion={false} />
      </div>
    )
  }
});

const HostRegistries = React.createClass({
  shouldComponentUpdate() {
    return false;
  },
  render() {
    const registries = window.evite_event.registries;
    let registryNodes = [];
    if (registries) {
      const registriesJson = JSON.parse(registries);
      for (let registry of registriesJson) {
        registryNodes.push(
          <li key={registry.registry_id}>
            <a href={registry.guest_url} target="_blank">
              <img src={registry.retailer_logo} alt={registry.retailer} />
            </a>
          </li>
        );
      }
    }
    if (!(window.show_registry_button || Boolean(window.gift_registry_provider))) {
      return null;
    }

    const isMobile = utils.isMobile();
    const providerClass = "provider-" + window.gift_registry_provider;
    const providerIcon = "icon-registry_" + window.gift_registry_provider;
    const registryIconClasses = "registry-icon " + providerClass + " " + providerIcon;
    const registryPresenceClass = `${!registries ? "no-registries" : "registries"}`;
    const providerIconClasses = `registry-provider-icon ${providerClass} ${registryPresenceClass}`;
    const poweredByClass = `powered-by ${providerClass} ${registryPresenceClass}`;
    const topClassNames = `simple-shadowbox gift-registries${isMobile ? " mobile" : ""}`;

    if (registries) {
      return (
        <div className={topClassNames}>
          <div className={registryIconClasses} />
          <div className="registry-text">
            <h3>Send a Gift</h3>
            <p>Your host has added a registry.</p>
          </div>
          { !isMobile &&
            <div className={poweredByClass}>
              <div className={providerIconClasses} />
            </div>
          }
          <div className="registry-divider"></div>
          <ul>
            {registryNodes}
          </ul>
          { isMobile &&
            <div className={poweredByClass}>
              <div className={providerIconClasses} />
            </div>
          }
        </div>
      );
    }
    return (
      <div className={topClassNames}>
        <div className={registryIconClasses} />
        <div className="registry-text">
          <h3>Find a Registry</h3>
          <p>Need to send a gift?
              <a href="#"
                className="find-registry"
                onClick={this.handleFindRegistryClick}>FIND REGISTRY</a></p>
        </div>
        <div className={poweredByClass}>
          <div className={providerIconClasses} />
        </div>
      </div>
    );
  },
  handleFindRegistryClick(e) {
    e.preventDefault();
    const url = urls.get('modal_knot_find_registry');
    new ModalView({
        url: `${url}?event_type=${window.evite_event.event_type}`
    }).show();
  }
});

function HostWishlist(props) {
  const url = `${window.evite_event.wishlist ? JSON.parse(window.evite_event.wishlist).listLink : "#"}`;
  const topClassNames = `simple-shadowbox wishlist${utils.isMobile() ? " mobile" : ""}`;

  return (
      <div className={topClassNames}>
        <div className="wishlist-icon icon-wishlist"></div>
        <div className="wishlist-text">
          <h3 className="wishlist-heading">Send a Gift</h3>
          <p className="wishlist-info">Your host has added a wish list.
          <a href={url} target="_blank">CHECK IT OUT</a></p>
        </div>
        <div className="powered-by">
          <div className="wishlist-provider"></div>
        </div>
      </div>
    );
}

export default Gifts;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/gifts/components.es6